module.exports = __webpack_public_path__ + "static/media/fourthareaproduct3.6308f9bc.jpg";